import React from "react";

import { Card, Label, Hint, TextInput, Counter } from "./ui";

const FooterCard = ({ footer, onChange }) => {
  return (
    <Card>
      <Label hint="optional">
        Footer text
        <span className="ml-2 font-normal">
          <Counter value={footer.text.length} max={60} />
        </span>
      </Label>
      <TextInput
        value={footer.text}
        maxLength={60}
        onChange={(e) => onChange({ text: e.target.value })}
        placeholder="Reply STOP to unsubscribe"
      />
      <Hint>A short line under the message. No variables or formatting.</Hint>
    </Card>
  );
};

export default FooterCard;
